<template>
    <div class="industry-litigation-card">
        <AonContainer>
            <AonRow class="mt-xl">
                <AonCol class="grid-cols-12 p-0 flex-column justify-center">
                    <AonCard
                        title="Industry Litigation & Coverage"
                        :desc="`Litigation trends related to the products and technologies of ${entityStore.entity.name}`"
                    >
                        <div class="card-content">
                            <AonCoverLoading
                                :loading="loading"
                                title="Loading Industry Litigation History..."
                                message="Products and Technology Areas within Moat2Product will need to be identified."
                            ></AonCoverLoading>
                            <AonRow class="mt-xl h-100 align-items-start">
                                <AonCol
                                    class="grid-cols-3 p-0 flex-column justify-center h-100"
                                    style="position: relative; overflow: hidden"
                                >
                                    <IndustryLitigationChart
                                        v-if="props.data.length > 0 && !loading"
                                        :chartData="props.data"
                                    />
                                </AonCol>
                                <AonCol class="grid-cols-9 p-0 flex-column justify-center h-100">
                                    <IndustryLitigationTable
                                        v-if="props.data.length > 0 && !loading"
                                        :tableData="props.data"
                                    />
                                </AonCol>
                            </AonRow>
                        </div>
                    </AonCard>
                </AonCol>
            </AonRow>
        </AonContainer>
    </div>
</template>

<script setup>
import { useEntityStore } from '@/stores'

import IndustryLitigationChart from './IndustryLitigationChart.vue'
import IndustryLitigationTable from './IndustryLitigationTable.vue'

const entityStore = useEntityStore()

const props = defineProps({
    loading: {
        type: Boolean,
        default: false,
    },
    data: {
        type: Array,
        default: () => [],
    },
})
</script>
<style lang="scss" scoped>
.industry-litigation-card {
    width: 100%;
    position: relative;

    .card-content {
        height: 500px;
    }
}
</style>
